import React from 'react';

const UserDetails = props => {
  const { orderDetails, dataLocale } = props;
  const { ADDRESS, ORDER_TOTAL } = dataLocale;

  return (
    <div className="user-detail-wrapper display-flex justify-space-between margin-t2">
      <div className="display-flex">
        <div className="margin-r40">
          <div className="fs14 fw700">{`${orderDetails?.result?.shippingAddress?.firstName} ${orderDetails?.result?.shippingAddress?.lastName}`}</div>
          <div className="fs12 fw400">{`${orderDetails?.result?.shippingAddress?.phoneCode}-${orderDetails?.result?.shippingAddress?.phone}`}</div>
          <div className="fs12 fw400">{orderDetails?.result?.shippingAddress?.email}</div>
        </div>
        <div style={{ width: '350px' }}>
          <div className="fs14 fw700">{ADDRESS}</div>
          <div className="fs12 fw400">{`${orderDetails?.result?.shippingAddress?.addressline1}, ${
            orderDetails?.result?.shippingAddress?.addressline2
              ? orderDetails?.result?.shippingAddress?.addressline2
              : ''
          }, ${orderDetails?.result?.shippingAddress?.city}, ${
            orderDetails?.result?.shippingAddress?.postcode
          }`}</div>
        </div>
      </div>
      <div>
        <div className="fs14 fw700">
          {ORDER_TOTAL}: {orderDetails?.result?.amount?.total}
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
